module.exports = __webpack_public_path__ + "static/burglars_pack-c2a59167168af6645d644b8768c2f09b.jpg";